import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Breadcrumb, RemoveDialogService } from 'src/app/shared/components';
import { Alocacao, AlocacaoService, Contrato, ContratoService } from 'src/app/contrato';
import { Condutor, CondutorService } from '../../condutor';
import { LocaisApresentacaoService, Orgao, OrgaoService, RegiaoAdmin, RegiaoAdminService } from 'src/app/localidade';
import { Servico, ServicoService } from 'src/app/servico';
import { catchErr, showInputError } from 'src/app/shared/utils';
import { StorageService } from 'src/app/shared/services';
import { StoragePageEnum } from 'src/app/shared/models';
import { RolesEnum } from 'src/app/core';
import { DioService } from '../dio.service';
import { Demandante, Dio } from '../dio.model';
import { DemandanteService } from '../demandante.service';
import { forkJoin, Observable } from 'rxjs';
import { LocaisApresentacao } from 'src/app/localidade/orgao/view-orgao/locais-apresentacao/locais-apresentacao.model';
import dayjs from 'dayjs';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { isSameDay } from 'src/app/shared/date-utils';
import { eachDayOfInterval } from 'date-fns/eachDayOfInterval';


@Component({
    selector: 'app-form-dio',
    templateUrl: './form-dio.component.html',
    standalone: false
})
export class FormDioComponent implements OnInit {

    loading: any = { main: true, save: false, alocacao: false, condutor: false };
    breadcrumb: Breadcrumb[] = [];
    dio = {} as Dio;
    lastDio = {} as Dio;
    title: string;

    incluirSei = false;

    alocacoes: Alocacao[];
    condutores: Condutor[];
    contratos: Contrato[];
    demandantes: Demandante[];

    locaisApresentacao: LocaisApresentacao[];
    orgaos: Orgao[];
    regioesAdm: RegiaoAdmin[];
    regioesAdmDemandante: RegiaoAdmin[];
    servicos: Servico[];

    demandante = {} as Demandante;
    showDemandanteForm: boolean;
    disableLocal: boolean;

    showInputError = showInputError;

    constructor(
        private activatedRoute: ActivatedRoute,
        private dioService: DioService,
        private dialog: MatDialog,
        private removeDialogService: RemoveDialogService,
        private router: Router,
        private snackBar: MatSnackBar,
        private alocacaoService: AlocacaoService,
        private regiaoAdmnistrativaService: RegiaoAdminService,
        private locaisApresentacaoService: LocaisApresentacaoService,
        private orgaoService: OrgaoService,
        private condutorService: CondutorService,
        private servicoService: ServicoService,
        private storageService: StorageService,
        private demandanteService: DemandanteService,
        private contratoService: ContratoService,
    ) { }

    ngOnInit() {        
        console.log('activeroute: ', this.activatedRoute.snapshot.url);
        if(this.activatedRoute.snapshot.url[1] && this.activatedRoute.snapshot.url[1].path === 'incluir-sei') {            
            this.incluirSei = true;
        }

        this.dio.id = this.activatedRoute.snapshot.params['idDio'];
        this.title = this.dio.id ? 'Editar' : 'Novo';
        this.breadcrumb = [
            { label: 'Início' },
            { label: 'Diários de Operação', route: '/dio' },
        ];

        this.dio.id && this.breadcrumb.push({ label: 'Visualizar DIO', route: `/dio/${this.dio.id}/visualizar` });
        this.breadcrumb.push({ label: this.title + ' DIO' });

        const storage = this.storageService.storage[StoragePageEnum.FormDio];
        if (storage && storage.dio) {
            this.dio = { ...storage.dio };
            console.log('carregou dio do storage: ', this.dio);
            this.storageService.remove(StoragePageEnum.FormDio);
        }

        this.getAllResources();
        if (this.dio.id) {            
            this.loading.main = true;
            this.dioService.getById<Dio>(this.dio.id).subscribe({
                next: (res) => {
                    this.dio = res;
                    this.dio.alocacao = { ...this.dio.alocacao, equipamento: `${this.dio.alocacao.equipamento.marca} ${this.dio.alocacao.equipamento.modelo}` };
                                   
                    //resolve problema de timezone na tela onde exibia sempre um dia a menos
                    if (this.dio.dataPeriodoInicioOperacao) {
                        this.dio.dataPeriodoInicioOperacao = new Date(this.dio.dataPeriodoInicioOperacao + 'T00:00:00');
                    }

                    if (this.dio.dataPeriodoFimOperacao) {
                        this.dio.dataPeriodoFimOperacao = new Date(this.dio.dataPeriodoFimOperacao + 'T00:00:00');
                    }

                    this.condutorService.getAllByBeneficiaria(this.dio.contrato.beneficiaria.id).subscribe((res) => {
                        this.condutores = res.data;
                    });
                },
                error: (err) => catchErr(err, this.snackBar)
            }).add(() => this.loading.main = false);
        }
    }

    compareWith(item: any, selected: any) {
        return item.id == selected
    }

    searchFn(term: string, item: any) {
        term = term?.toLocaleLowerCase();
        return item?.nome?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.titulo?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.firstName?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.lastName?.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.codigo && item?.codigo.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.equipamento && item?.equipamento.toLocaleLowerCase().indexOf(term) > -1;
    }

    setContrato(contrato: Contrato) {
        this.getConditionalResources(contrato.id, contrato.beneficiaria.id);
        this.dio = { ...this.dio, contrato: contrato.id }
    }

    buscarDioJaExistenteCriado(): Observable<Dio> {
        return this.dioService.findLastDio(
            this.dio.contrato,
            this.dio.alocacao,
            this.dio.condutor,
            this.dio.servico,
            this.dio.orgao,
            this.dio.dataPeriodoInicioOperacao ? dayjs(this.dio.dataPeriodoInicioOperacao).format('YYYY-MM-DD') : ''
        );
    }

    setOrgao(orgao?: Orgao) {
        this.disableLocal = false;
        if (orgao) {
            this.dio = {
                ...this.dio,
                orgao: orgao.id,
                regiaoAdm: orgao?.regiaoAdministrativa?.id,
            };
        } else {
            this.dio = {
                ...this.dio,
                orgao: undefined,
                regiaoAdm: undefined,
                localApresentacao: undefined,
            };
            this.locaisApresentacao = undefined as any;
            this.disableLocal = true;
        }

        if (orgao?.locaisApresentacao) {
            if (!orgao?.locaisApresentacao.length) {
                this.disableLocal = true;
            } else {
                this.locaisApresentacao = orgao?.locaisApresentacao;
                this.dio.localApresentacao = orgao?.locaisApresentacao[0].id;
            }
        }        
    }

    setRegiaoAdm(ra: RegiaoAdmin) {
        if (ra) {
            this.dio = {
                ...this.dio,
                regiaoAdm: ra.id,
            };
        }
    }

    addDemandante = ($event: any) => {
        this.showDemandanteForm = true;
        this.demandante.nome = $event;
    }

    routeWithStorage(route: string, objKey: string) {
        !this.dio.id && this.storageService.set(StoragePageEnum.FormCondutor, { condutor: this.dio })
        this.router.navigate([route], { queryParams: { returnObj: objKey, userRole: RolesEnum.CONTRATADO_CONDUTOR } });
    }

    async preSave(){
        this.buscarDioJaExistenteCriado().subscribe({
            next: (res) => {
                this.lastDio = res;

                if(this.lastDio){                                        
                    this.dialog.open(DioExistenteDialog, {
                        data: {
                            dio: this.lastDio,
                            demandante: this.demandante,
                        },
                        width: '100vh'
                    });                    
                } else {
                    this.saveOrUpdate();
                }
            }
        });
    }

    saveOrUpdate() {
        this.dio.id ? this.update() : this.save();
    }

    update() {
        if (!this.dio.id) {
            console.log('returning on update');
            return;
        }

        this.loading.save = true;
        delete this.dio.endereco;

        const DioToUpdate = {
            ...this.dio,
            servico: this.dio.servico && this.dio.servico.id ? this.dio.servico.id : this.dio.servico,
            alocacao: this.dio.alocacao && this.dio.alocacao.id ? this.dio.alocacao.id : this.dio.alocacao,
            condutor: this.dio.condutor && this.dio.condutor.id ? this.dio.condutor.id : this.dio.condutor,
            contrato: this.dio.contrato && this.dio.contrato.id ? this.dio.contrato.id : this.dio.contrato,
            orgao: this.dio.orgao && this.dio.orgao.id,
            localApresentacao: this.dio.localApresentacao && this.dio.localApresentacao.id,
            execucaoDetalhes: undefined,
            demandante: this.demandante && this.demandante.nome ? this.demandante : this.dio.demandante,
            regiaoAdm: this.dio.regiaoAdm && this.dio.regiaoAdm.id,
        }
        
        this.dioService.update<Dio>(this.dio.id, DioToUpdate).subscribe({
            next: () => {
                this.snackBar.open('DIO editada com sucesso!', '✕', { panelClass: ['success'] });
                this.router.navigate(['/dio']);
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading.save = false);
    }

    save() {
        console.log('entrou save');
        this.loading.save = true;
        delete this.dio.endereco;

        const DioToSave = {
            ...this.dio,
            execucaoDetalhes: undefined,
            demandante: this.demandante && this.demandante.nome ? this.demandante : this.dio.demandante,
        }

        this.dioService.create<Dio>(DioToSave).subscribe({
            next: () => {
                this.snackBar.open('DIO salva com sucesso!', '✕', { panelClass: ['success'] });
                this.router.navigate(['/dio']);
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading.save = false);
    }

    setAlocacao(alocacao: Alocacao) {
        console.log('set alocacao ' + alocacao.id);
        this.loading.main = true;

        this.dio = { ...this.dio, alocacao: alocacao?.id }

        if(alocacao){
            this.dioService.findLastDioByContrato(alocacao.contrato.id, alocacao.id).subscribe({
                next: (res) => {
                    this.lastDio = res;                    
    
                    if(this.lastDio){
    
                        this.dio = {
                            ...this.dio,
                            orgao: this.lastDio.orgao ? this.lastDio.orgao.id : undefined,
                            regiaoAdm: this.lastDio.regiaoAdm?.id,
                            localApresentacao: this.lastDio.localApresentacao ? this.lastDio.localApresentacao.id : undefined,
                            servico: this.lastDio.servico ? this.lastDio.servico.id : undefined,
                            condutor: this.lastDio.condutor ? this.lastDio.condutor.id : undefined,
                            demandante: this.lastDio.demandante ? this.lastDio.demandante.id : undefined,
                            funcionarioResponsavelOrgao: this.lastDio.funcionarioResponsavelOrgao
                        };
                    }
                },
                error: (err) => catchErr(err, this.snackBar)
            }).add(() => this.loading.main = false);
        }
    }

    private getAllResources() {
        forkJoin([
            this.contratoService.getAll<Contrato>(true),
            this.demandanteService.getAll<Demandante>(),
            this.locaisApresentacaoService.getAll<LocaisApresentacao>(),
            this.orgaoService.getAll<Orgao>(),
            this.regiaoAdmnistrativaService.getAll<RegiaoAdmin>(),
            this.servicoService.getAll<Servico>(),
        ]).subscribe({
            next: ([resContrato, resDemandante, resLocais, resOrgao, resRa, resServico]) => {
                this.contratos = resContrato.data;
                this.demandantes = resDemandante.data;
                this.locaisApresentacao = resLocais.data;
                this.orgaos = resOrgao.data;
                this.regioesAdm = resRa.data;
                this.regioesAdmDemandante = resRa.data;
                this.servicos = resServico.data;
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading.main = false)
    }

    private getConditionalResources(contratoId: string, beneficiariaId: string) {
        this.loading.alocacao = true;
        this.loading.condutor = true;
        forkJoin([
            this.alocacaoService.getAll<Alocacao>(contratoId, undefined, true),
            this.condutorService.getAllByBeneficiaria(beneficiariaId),
        ]).subscribe({
            next: ([resAlocacao, resCondutor]) => {                
                this.alocacoes = resAlocacao.data.map((alocacao) => ({
                    ...alocacao,
                    placa: alocacao.equipamento.placa,
                    equipamento: `${alocacao.equipamento.marca} ${alocacao.equipamento.modelo}`,
                    inicioVigencia: dayjs(alocacao.inicioVigencia).format('DD/MM/YYYY'),
                    fimVigencia: dayjs(alocacao.fimVigencia).format('DD/MM/YYYY')
                }));
                console.log('res condutor: ', resCondutor);
                //this.condutores = resCondutor.data.filter(condutor => condutor.enabled === true);
                this.condutores = resCondutor.data;
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => {
            this.loading.alocacao = false;
            this.loading.condutor = false;
        });
    }

    showRemoveDialog() {
        this.removeDialogService.show('DIO', (dialogRef: MatDialogRef<any>) => {
            this.dioService.remove<Dio>(this.dio.id || '').subscribe({
                next: () => {
                    this.snackBar.open('DIO apagada com sucesso!', '✕', { panelClass: ['success'] });
                    this.router.navigate(['/dio'], { queryParams: { tab: 'dios' } });
                    dialogRef.close();
                }, error: (err) => catchErr(err, this.snackBar)
            })
        }, 'Apagar');
    }

    onDateChange(event: MatDatepickerInputEvent<Date>) {
        const selectedDate = event.value;
        this.dio.dataPeriodoFimOperacao = selectedDate ? selectedDate : undefined;        
    }
}


@Component({
    selector: 'dio-existente-dialog',
    templateUrl: './dio-existente-dialog.html',
    standalone: false
})
export class DioExistenteDialog {
    constructor(
        public dialogRef: MatDialogRef<DioExistenteDialog>,
        private dioService: DioService,
        private router: Router,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: { dio: Dio, demandante: Demandante },
    ) {}

    loading = false;
    dio: Dio;
    demandante: Demandante;

    confirm() {
        console.log('data confirming dio: ', this.data);
        this.dio = this.data.dio;
        this.demandante = this.data.demandante;

        this.loading = true;
        delete this.dio.endereco;
        delete this.dio.id;
        delete this.dio.created_at;

        const DioToSave = {
            ...this.dio,
            alocacao: this.dio.alocacao.id,
            contrato: this.dio.contrato.id,
            servico: this.dio.servico.id,
            orgao: this.dio.orgao.id,
            regiaoAdm: this.dio.regiaoAdm ? this.dio.regiaoAdm.id : undefined,
            localApresentacao: this.dio.localApresentacao ? this.dio.localApresentacao.id : undefined,
            condutor: this.dio.condutor.id,
            execucaoDetalhes: undefined,
            demandante: this.demandante && this.demandante.nome ? this.demandante : this.dio.demandante,
        }

        this.dioService.create<Dio>(DioToSave).subscribe({
            next: () => {
                this.snackBar.open('DIO salva com sucesso!', '✕', { panelClass: ['success'] });
                this.router.navigate(['/dio']);
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => {this.loading = false; this.dialogRef.close();});        
    }
    
}